function getBundleVariantData(productId) {
  const el = document.getElementById(`variantData-${productId}`);
  if (!el) return {};

  try {
    return JSON.parse(el.textContent);
  } catch {
    return {};
  }
}

function updateBundleComponentImage(component) {
  const productId = component.dataset.productId;
  const side = component.dataset.componentIndex; 
  const variantId = component.querySelector('.bundle-selected-variant')?.value;

  if (!productId || !variantId || !side) return;

  const variantData = getBundleVariantData(productId)[variantId];
  if (!variantData) return;

  const url = variantData.bundle_image;
  if (!url) return;

  const section = component.closest('.bundle-product');
  const giftbox = section?.classList.contains('bundle-product--giftbox');
  const selector = giftbox
    ? `[data-bundle-slot="${side}"] img`
    : side === '1'
      ? '[data-bundle-left-image] img'
      : '[data-bundle-right-image] img';

  const img = (section || document).querySelector(selector);
  if (img) img.src = url;
}

function updateAllBundleImages() {
  document
    .querySelectorAll('.bundle-component')
    .forEach(updateBundleComponentImage);
}

// Skip snap-back during the page-load swatch pass
let bundleReady = false;

function snapBundleGalleryToStart() {
  if (!bundleReady) return;

  const swiper = document.querySelector('.bundle-product .carousel_product')?.swiper;
  if (!swiper || swiper.activeIndex === 0) return;

  swiper.slideTo(0);
}

function dispatchBundleVariantChange(component) {
  const productId = component.dataset.productId;
  const componentIndex = component.dataset.componentIndex;
  const variantId = component.querySelector('.bundle-selected-variant')?.value;

  if (!productId || !variantId) return;

  document.dispatchEvent(
    new CustomEvent('bundle:variant-change', {
      detail: { productId, variantId, componentIndex }
    })
  );
}

function getBundleProduct(id) {
  const el = document.querySelector(`#bundleProduct-${id}`);
  return el ? JSON.parse(el.textContent) : null;
}

function getMainBundleProduct(copyProductId) {
  const el = document.getElementById(`mainBundleProduct-${copyProductId}`);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function isCopyVariantSoldAvailable(copyProductId, copyVariant) {
  const variantData = getBundleVariantData(copyProductId);
  const mainVariantId = variantData[String(copyVariant.id)]?.main_variant_id;
  const mainProduct = getMainBundleProduct(copyProductId);

  // Prefer availability from the full main product JSON (reliable storefront stock).
  if (mainProduct && mainVariantId != null) {
    const mainVariant = mainProduct.variants.find(
      v => String(v.id) === String(mainVariantId)
    );
    if (mainVariant) return !!mainVariant.available;
  }

  // Fallback: liquid-embedded flag, then copy variant availability.
  const mapped = variantData[String(copyVariant.id)]?.main_variant_available;
  if (typeof mapped === 'boolean') return mapped;
  return !!copyVariant.available;
}

function syncBundleAddToCartState() {
  const atcBtn = document.querySelector('#bundle-form .product__buttons .button');
  if (!atcBtn) return;

  const components = Array.from(document.querySelectorAll('.bundle-component'));
  const anyComponentSoldOut = components.some(component => {
    const product = getBundleProduct(component.dataset.productId);
    if (!product) return true;

    let colourIndex = null;
    product.options.forEach((name, i) => {
      const lower = name.toLowerCase();
      if (lower.includes('colour') || lower.includes('color')) colourIndex = i + 1;
    });
    if (!colourIndex) colourIndex = 1;

    const colourGroup = component.querySelector(
      `.product__variant-pills[data-option-position="${colourIndex}"]`
    );
    if (!colourGroup) return false;

    const buttons = Array.from(colourGroup.querySelectorAll('button'));
    if (!buttons.length) return false;
    return buttons.every(btn => btn.classList.contains('hidden'));
  });

  if (anyComponentSoldOut) {
    atcBtn.classList.add('btn-disabled');
    atcBtn.setAttribute('disabled', 'disabled');
    atcBtn.innerHTML = 'Sold Out';
  } else {
    atcBtn.classList.remove('btn-disabled');
    atcBtn.removeAttribute('disabled');
    atcBtn.innerHTML = 'Add to Cart';
  }
}

function updateBundleAvailability(component) {
  const productId = component.dataset.productId;
  const product = getBundleProduct(productId);
  if (!product) return;

  const variants = product.variants;
  const optionNames = product.options; // ["Colour", "Size"]

  // Prefer mapped main-variant stock so swatches match what will actually sell.
  const isSoldAvailable = (copyVariant) =>
    isCopyVariantSoldAvailable(productId, copyVariant);

  // Detect which option is colour and which is size
  let colourIndex = null;
  let sizeIndex = null;

  optionNames.forEach((name, i) => {
    const lower = name.toLowerCase();
    if (lower.includes('colour') || lower.includes('color'))
      colourIndex = i + 1;
    if (lower.includes('size')) sizeIndex = i + 1;
  });

  // Safety fallback: if detection fails, assume option1 = colour, option2 = size
  if (!colourIndex) colourIndex = 1;
  if (!sizeIndex) sizeIndex = 2;

  const colourGroup = component.querySelector(
    `.product__variant-pills[data-option-position="${colourIndex}"]`
  );

  const sizeGroup = component.querySelector(
    `.product__variant-pills[data-option-position="${sizeIndex}"]`
  );

  const activeColour = colourGroup
    ? colourGroup.querySelector('.active')?.dataset.value || null
    : variants[0][`option${colourIndex}`];

  const activeSize = sizeGroup
    ? sizeGroup.querySelector('.active')?.dataset.value || null
    : variants[0][`option${sizeIndex}`];

  // Find all colours available for this size
  const availableColoursForSize = variants
    .filter(
      v => v[`option${sizeIndex}`] === activeSize && isSoldAvailable(v)
    )
    .map(v => v[`option${colourIndex}`]);

  let finalColour = activeColour;

  // If the current colour is not available for this size → fallback
  if (
    colourGroup &&
    !availableColoursForSize.includes(activeColour)
  ) {
    finalColour = availableColoursForSize[0];

    colourGroup.querySelectorAll('button').forEach(btn => {
      btn.classList.toggle(
        'active',
        btn.dataset.value === finalColour
      );
    });
  }

  if (colourGroup) {
    colourGroup.querySelectorAll('button').forEach(btn => {
      const val = btn.dataset.value;
      btn.classList.toggle('hidden', !availableColoursForSize.includes(val));
      btn.classList.remove('btn-disabled');
    });
  }

  // Sizes are NEVER disabled — so we leave sizeGroup untouched

  // Resolve correct variant
  const finalVariant = variants.find(
    v =>
      v[`option${colourIndex}`] === finalColour &&
      v[`option${sizeIndex}`] === activeSize &&
      isSoldAvailable(v)
  );

  // Update hidden variant ID
  if (finalVariant) {
    component.querySelector('.bundle-selected-variant').value =
      finalVariant.id;

    updateBundleComponentImage(component);
    dispatchBundleVariantChange(component);
  }

  syncBundleAddToCartState();
}

function normaliseBundleOptionValue(value) {
  return String(value || '').trim().toLowerCase();
}

function getBundleColourOptionIndex(product) {
  if (!product?.options) return null;

  let colourIndex = null;
  product.options.forEach((name, i) => {
    const lower = String(name).toLowerCase();
    if (lower.includes('colour') || lower.includes('color')) colourIndex = i + 1;
  });

  return colourIndex;
}

function resolveGiftboxColourMatch(component, colourValue) {
  const product = getBundleProduct(component.dataset.productId);
  const colourIndex = getBundleColourOptionIndex(product);
  if (!colourIndex) return null;

  const target = normaliseBundleOptionValue(colourValue);
  const group = component.querySelector(
    `.product__variant-pills[data-option-position="${colourIndex}"]`
  );

  if (group) {
    const button = Array.from(group.querySelectorAll('button')).find(
      btn =>
        normaliseBundleOptionValue(btn.dataset.value) === target &&
        !btn.classList.contains('hidden')
    );
    return button ? { button } : null;
  }

  const optionBox = component.querySelectorAll('.product__variant')[colourIndex - 1];
  const selected = optionBox?.querySelector('.selected-value')?.textContent;
  if (normaliseBundleOptionValue(selected) === target) return { button: null };

  return null;
}

let syncingGiftboxColours = false;

function syncGiftboxColoursFromFirstItem(button, component) {
  if (!bundleReady || syncingGiftboxColours) return;

  const section = component.closest('.bundle-product--giftbox');
  if (!section || component.dataset.componentIndex !== '1') return;

  const product = getBundleProduct(component.dataset.productId);
  const colourIndex = getBundleColourOptionIndex(product);
  const group = button.closest('.product__variant-pills');
  if (!colourIndex || !group) return;
  if (String(group.dataset.optionPosition) !== String(colourIndex)) return;

  const second = section.querySelector('.bundle-component[data-component-index="2"]');
  const third = section.querySelector('.bundle-component[data-component-index="3"]');
  if (!second || !third) return;

  const secondMatch = resolveGiftboxColourMatch(second, button.dataset.value);
  const thirdMatch = resolveGiftboxColourMatch(third, button.dataset.value);
  if (!secondMatch || !thirdMatch) return;

  syncingGiftboxColours = true;
  try {
    [secondMatch, thirdMatch].forEach(match => {
      if (!match.button || match.button.classList.contains('active')) return;
      bundleSelectOption(match.button);
    });
  } finally {
    syncingGiftboxColours = false;
  }
}

function bundleSelectOption(button) {
  const group = button.closest('.product__variant-pills');
  if (!group) return;

  const comp = button.closest('.bundle-component');
  const productId = comp.dataset.productId;

  group
    .querySelectorAll('button')
    .forEach(b => b.classList.remove('active'));
  button.classList.add('active');

  // Update selected text in the title
  const variantBox = group.closest('.product__variant');
  const selectedValueEl = variantBox.querySelector('.selected-value');
  if (selectedValueEl) {
    selectedValueEl.textContent = button.dataset.value;
  }

  updateBundleAvailability(comp);

  const variant = button.dataset.valueId;

  // const chosen = [];
  // comp.querySelectorAll('.product__variant-pills').forEach(g => {
  //   const active = g.querySelector('.active');
  //   chosen.push(active ? active.dataset.value : '');
  // });

  // const data = getBundleProduct(productId);
  // if (!data) {
  //   return;
  // }

  // const variant = data.variants.find(
  //   v =>
  //     v.option1 === chosen[0] &&
  //     (!v.option2 || v.option2 === chosen[1]) &&
  //     (!v.option3 || v.option3 === chosen[2])
  // );

  if (variant) {
    comp.querySelector('.bundle-selected-variant').value = variant;
  }

  updateBundleComponentImage(comp);
  dispatchBundleVariantChange(comp);
  updateBundleComponentsProperty();
  snapBundleGalleryToStart();
  syncGiftboxColoursFromFirstItem(button, comp);
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.bundle-component')
    .forEach(component => {
      updateBundleAvailability(component);

      component
        .querySelectorAll('.product__variant-pills')
        .forEach(group => {
          const firstBtn =
            group.querySelector('button.active:not(.hidden)') ||
            group.querySelector('button:not(.hidden)');
          if (firstBtn) {
            firstBtn.click();
          }
        });
    });

  updateAllBundleImages();
  updateBundleComponentsProperty();
  syncBundleAddToCartState();

  bundleReady = true;
});

function updateBundleComponentsProperty() {
  const ids = [];
  const components = [];

  document
    .querySelectorAll('.bundle-component .bundle-selected-variant')
    .forEach(input => {
      if (!input.value) return;

      const copyVariantId = String(input.value);
      const componentEl = input.closest('.bundle-component');
      const productId = componentEl?.dataset.productId;

      // Resolve copy variant -> main variant so the SOLD line item
      // decrements the main product's inventory, not the copy's.
      const mainVariantId =
        (productId &&
          getBundleVariantData(productId)[copyVariantId]?.main_variant_id) ||
        null;

      if (!mainVariantId) {
        console.warn(
          `[bundle] Missing main_variant_id for copy variant ${copyVariantId}; ` +
          `falling back to copy variant (inventory will decrement the copy).`
        );
      }

      const soldId = mainVariantId ? String(mainVariantId) : copyVariantId;
      const gid = soldId.startsWith('gid://')
        ? soldId
        : `gid://shopify/ProductVariant/${soldId}`;
      ids.push(gid);

      // Unchanged: per-component qty + Meta tracking still reference the copy.
      const qty =
        parseInt(componentEl?.querySelector('[name="quantity"]')?.value, 10) || 1;
      components.push({ variantId: copyVariantId, quantity: qty });
    });

  const packagingId = document.getElementById('bundle-form')?.dataset.packagingVariantId;
  if (packagingId) {
    const packagingGid = String(packagingId).startsWith('gid://')
      ? String(packagingId)
      : `gid://shopify/ProductVariant/${packagingId}`;
    ids.push(packagingGid);
  }

  const bundleInput = document.getElementById('bundle-components');
  if (bundleInput) {
    bundleInput.value = JSON.stringify(ids);
  }

  // Expose for Meta bundle tracking
  window.bundleComponents = components;

  // Bundle total price (minor units). Use a reliable source if you have one in DOM.
  // Example: a hidden input you control, or a price element with cents on dataset.
  const totalEl = document.querySelector('[data-bundle-total-cents]');
  const totalCents = totalEl ? parseInt(totalEl.getAttribute('data-bundle-total-cents'), 10) : 0;
  window.bundleTotalPrice = Number.isFinite(totalCents) ? totalCents : 0;
}

document
  .getElementById('bundle-form')
  ?.addEventListener('submit', () => {
    updateBundleComponentsProperty();
  });
